<template>
  <!--  <div class="d-flex align-center justify-center">
      <img :src="require('@/assets/no-geofence.png')" alt="logo">
      <div class="font-weight-bold body-1 ml-5">{{ $t('zones.noHistoryOfGeofenceEvents') }}</div>
    </div>-->
    <TabBasic ref="tabBasic" :actual-breadcrumb="actualBreadcrumb" show-breadcrumbs>
        <AlertHistory :user-id="$store.getters.getUserId"/>
    </TabBasic>
</template>

<script>
import AlertHistory from "@/components/Alert/AlertHistory";
import TabBasic from "@/components/reusable/TabBasic/TabBasic";

export default {
  name: "CircleHistory",
  components: {TabBasic, AlertHistory,},
  mounted() {
    this.getCircle();
  },
  data() {
    return {
      circle: {},
    };
  },
  computed: {
    organizationId() {
      return this.$store.getters.getOrganizationId;
    },
    actualBreadcrumb() {
      if (this.circle && this.circle.Name) {
        return [{
          text: this.circle.Name + ' - ' + this.$t('notifications.history')
        }];
      }
      return [{
        text: this.$t('notifications.history')
      }];
    },
  },
  methods: {
    getCircle() {
      const url = this.$store.getters.circles(this.organizationId, this.$route.params.id);
      this.loading = true;
      this.axios.get(url).then(({data}) => {
        this.circle = data.Result;
      });

    },
  }
};
</script>

<style scoped>

</style>